const firebaseConfig = {
    apiKey: "AIzaSyCiHnNnWV-hGUUutRnx4-NQ1ugnTuRFVQ0",
    authDomain: "sh-login-56607.firebaseapp.com",
    projectId: "sh-login-56607",
    storageBucket: "sh-login-56607.appspot.com",
    messagingSenderId: "560566567591",
    appId: "1:560566567591:web:bb366227a642ac43679182"
  };


  export default firebaseConfig;